export default __webpack_public_path__ + "static/media/cleaning9.2f5b5511.jpg";